@file:OptIn(InternalResourceApi::class)

package loco

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/loco/"

@delegate:ResourceContentHash(-1_925_640_512)
public val Res.string.GENERAL_UNIT_ML_LABEL: StringResource by lazy {
      StringResource("string:GENERAL_UNIT_ML_LABEL", "GENERAL_UNIT_ML_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5999, 33),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5979, 33),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6175, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5559, 33),
      ))
    }

@delegate:ResourceContentHash(1_298_412_992)
public val Res.string.GENERAL_UNIT_OZ_LABEL: StringResource by lazy {
      StringResource("string:GENERAL_UNIT_OZ_LABEL", "GENERAL_UNIT_OZ_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 6033, 33),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6013, 33),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6209, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5593, 33),
      ))
    }

@delegate:ResourceContentHash(-449_354_507)
public val Res.string.GENERAL_UNIT_PIECE_LABEL: StringResource by lazy {
      StringResource("string:GENERAL_UNIT_PIECE_LABEL", "GENERAL_UNIT_PIECE_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 6067, 44),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6047, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6243, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5627, 44),
      ))
    }

@delegate:ResourceContentHash(1_773_853_336)
public val Res.string.GENERAL_UNIT_TBSP_LABEL: StringResource by lazy {
      StringResource("string:GENERAL_UNIT_TBSP_LABEL", "GENERAL_UNIT_TBSP_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 6112, 35),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6092, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6288, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5672, 39),
      ))
    }

@delegate:ResourceContentHash(-1_277_038_355)
public val Res.string.GENERAL_UNIT_TSP_LABEL: StringResource by lazy {
      StringResource("string:GENERAL_UNIT_TSP_LABEL", "GENERAL_UNIT_TSP_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 6148, 34),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6136, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6336, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5712, 34),
      ))
    }

@delegate:ResourceContentHash(146_994_466)
public val Res.string.GENERAL_WEIGHT_CUP_FORMAT: StringResource by lazy {
      StringResource("string:GENERAL_WEIGHT_CUP_FORMAT", "GENERAL_WEIGHT_CUP_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 6183, 49),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6183, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6383, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5747, 45),
      ))
    }

@delegate:ResourceContentHash(-2_120_798_464)
public val Res.string.GENERAL_WEIGHT_FL_OZ_FORMAT: StringResource by lazy {
      StringResource("string:GENERAL_WEIGHT_FL_OZ_FORMAT", "GENERAL_WEIGHT_FL_OZ_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 6233, 51),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6233, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6433, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5793, 51),
      ))
    }

@delegate:ResourceContentHash(1_031_063_104)
public val Res.string.GENERAL_WEIGHT_GRAM_FORMAT: StringResource by lazy {
      StringResource("string:GENERAL_WEIGHT_GRAM_FORMAT", "GENERAL_WEIGHT_GRAM_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 6285, 42),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6285, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6485, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5845, 42),
      ))
    }

@delegate:ResourceContentHash(-56_044_352)
public val Res.string.GENERAL_WEIGHT_KG_FORMAT: StringResource by lazy {
      StringResource("string:GENERAL_WEIGHT_KG_FORMAT", "GENERAL_WEIGHT_KG_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 6328, 44),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6328, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6528, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5888, 44),
      ))
    }

@delegate:ResourceContentHash(1_213_401_408)
public val Res.string.GENERAL_WEIGHT_LB_FORMAT: StringResource by lazy {
      StringResource("string:GENERAL_WEIGHT_LB_FORMAT", "GENERAL_WEIGHT_LB_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 6373, 44),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6373, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6573, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5933, 44),
      ))
    }

@delegate:ResourceContentHash(-80_249_178)
public val Res.string.GENERAL_WEIGHT_MEAL_FORMAT: StringResource by lazy {
      StringResource("string:GENERAL_WEIGHT_MEAL_FORMAT", "GENERAL_WEIGHT_MEAL_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 6418, 58),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6418, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6618, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5978, 50),
      ))
    }

@delegate:ResourceContentHash(-1_882_028_608)
public val Res.string.GENERAL_WEIGHT_ML_FORMAT: StringResource by lazy {
      StringResource("string:GENERAL_WEIGHT_ML_FORMAT", "GENERAL_WEIGHT_ML_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 6477, 44),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6469, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6669, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6029, 44),
      ))
    }

@delegate:ResourceContentHash(-1_226_223_168)
public val Res.string.GENERAL_WEIGHT_OZ_FORMAT: StringResource by lazy {
      StringResource("string:GENERAL_WEIGHT_OZ_FORMAT", "GENERAL_WEIGHT_OZ_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 6522, 44),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6514, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6714, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6074, 44),
      ))
    }

@delegate:ResourceContentHash(-1_694_513_897)
public val Res.string.GENERAL_WEIGHT_PIECE_FORMAT: StringResource by lazy {
      StringResource("string:GENERAL_WEIGHT_PIECE_FORMAT", "GENERAL_WEIGHT_PIECE_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 6567, 55),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6559, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6759, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6119, 55),
      ))
    }

@delegate:ResourceContentHash(-2_078_788_999)
public val Res.string.GENERAL_WEIGHT_TBSP_FORMAT: StringResource by lazy {
      StringResource("string:GENERAL_WEIGHT_TBSP_FORMAT", "GENERAL_WEIGHT_TBSP_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 6623, 46),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6615, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6815, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6175, 46),
      ))
    }

@delegate:ResourceContentHash(-240_336_939)
public val Res.string.GENERAL_WEIGHT_TSP_FORMAT: StringResource by lazy {
      StringResource("string:GENERAL_WEIGHT_TSP_FORMAT", "GENERAL_WEIGHT_TSP_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 6670, 45),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6674, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6874, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6222, 45),
      ))
    }

@delegate:ResourceContentHash(-947_714_304)
public val Res.string.HEALTH_KIT_APPLE_HEALTH_NAME: StringResource by lazy {
      StringResource("string:HEALTH_KIT_APPLE_HEALTH_NAME", "HEALTH_KIT_APPLE_HEALTH_NAME", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 6716, 52),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6736, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6932, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6268, 52),
      ))
    }

@delegate:ResourceContentHash(-845_495_140)
public val Res.string.HEALTH_KIT_CONNECTION_TITLE_FORMAT: StringResource by lazy {
      StringResource("string:HEALTH_KIT_CONNECTION_TITLE_FORMAT", "HEALTH_KIT_CONNECTION_TITLE_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 6769, 62),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6789, 66),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6985, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6321, 62),
      ))
    }

@delegate:ResourceContentHash(374_878_339)
public val Res.string.HEALTH_KIT_CONNECT_BUTTON: StringResource by lazy {
      StringResource("string:HEALTH_KIT_CONNECT_BUTTON", "HEALTH_KIT_CONNECT_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 6832, 45),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6856, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7052, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6384, 45),
      ))
    }

@delegate:ResourceContentHash(-584_221_376)
public val Res.string.HEALTH_KIT_HEALTH_CONNECT_NAME: StringResource by lazy {
      StringResource("string:HEALTH_KIT_HEALTH_CONNECT_NAME", "HEALTH_KIT_HEALTH_CONNECT_NAME", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 6878, 58),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6902, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7098, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6430, 58),
      ))
    }

@delegate:ResourceContentHash(-1_507_885_409)
public val Res.string.HEALTH_KIT_MANAGE_HINT_ANDROID_FORMAT: StringResource by lazy {
      StringResource("string:HEALTH_KIT_MANAGE_HINT_ANDROID_FORMAT", "HEALTH_KIT_MANAGE_HINT_ANDROID_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 6937, 177),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6961, 145),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7157, 153),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6489, 129),
      ))
    }

@delegate:ResourceContentHash(-876_875_917)
public val Res.string.HEALTH_KIT_MANAGE_HINT_IOS_FORMAT: StringResource by lazy {
      StringResource("string:HEALTH_KIT_MANAGE_HINT_IOS_FORMAT", "HEALTH_KIT_MANAGE_HINT_IOS_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 7115, 301),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7107, 289),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7311, 321),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6619, 241),
      ))
    }

@delegate:ResourceContentHash(-1_983_722_249)
public val Res.string.HEALTH_KIT_MANAGE_PERMISSIONS_BUTTON: StringResource by lazy {
      StringResource("string:HEALTH_KIT_MANAGE_PERMISSIONS_BUTTON", "HEALTH_KIT_MANAGE_PERMISSIONS_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 7417, 76),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7397, 68),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7633, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6861, 68),
      ))
    }

@delegate:ResourceContentHash(1_032_318_782)
public val Res.string.HEALTH_KIT_SYNC_DESCRIPTION: StringResource by lazy {
      StringResource("string:HEALTH_KIT_SYNC_DESCRIPTION", "HEALTH_KIT_SYNC_DESCRIPTION", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 7494, 203),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7466, 159),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7710, 195),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6930, 143),
      ))
    }

@delegate:ResourceContentHash(630_826_176)
public val Res.string.HEALTH_LOG_SAVE_BUTTON: StringResource by lazy {
      StringResource("string:HEALTH_LOG_SAVE_BUTTON", "HEALTH_LOG_SAVE_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 7698, 42),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7626, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7906, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7074, 38),
      ))
    }

@delegate:ResourceContentHash(437_537_384)
public val Res.string.HEALTH_LOG_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:HEALTH_LOG_SCREEN_TITLE", "HEALTH_LOG_SCREEN_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 7741, 63),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7669, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7949, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7113, 47),
      ))
    }

@delegate:ResourceContentHash(-1_379_943_212)
public val Res.string.HEALTH_TOOLS_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:HEALTH_TOOLS_SCREEN_TITLE", "HEALTH_TOOLS_SCREEN_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 7805, 57),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7729, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8017, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7161, 49),
      ))
    }

@delegate:ResourceContentHash(-1_858_052_674)
public val Res.string.INSIGHTS_FAVORITES_EMPTY_BUTTON_TEXT: StringResource by lazy {
      StringResource("string:INSIGHTS_FAVORITES_EMPTY_BUTTON_TEXT", "INSIGHTS_FAVORITES_EMPTY_BUTTON_TEXT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 7863, 72),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7791, 72),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8075, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7211, 64),
      ))
    }

@delegate:ResourceContentHash(-972_960_409)
public val Res.string.INSIGHTS_FAVORITES_EMPTY_MESSAGE: StringResource by lazy {
      StringResource("string:INSIGHTS_FAVORITES_EMPTY_MESSAGE", "INSIGHTS_FAVORITES_EMPTY_MESSAGE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 7936, 208),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7864, 184),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8152, 212),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7276, 168),
      ))
    }

@delegate:ResourceContentHash(-1_477_019_615)
public val Res.string.INSIGHTS_FAVORITES_EMPTY_TITLE: StringResource by lazy {
      StringResource("string:INSIGHTS_FAVORITES_EMPTY_TITLE", "INSIGHTS_FAVORITES_EMPTY_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 8145, 70),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8049, 82),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8365, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7445, 70),
      ))
    }

@delegate:ResourceContentHash(2_134_142_920)
public val Res.string.INSIGHTS_GREETING: StringResource by lazy {
      StringResource("string:INSIGHTS_GREETING", "INSIGHTS_GREETING", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 8260, 45),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8176, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8496, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7560, 45),
      ))
    }

@delegate:ResourceContentHash(234_037_199)
public val Res.string.INSIGHTS_GREETING_NAME_FALLBACK: StringResource by lazy {
      StringResource("string:INSIGHTS_GREETING_NAME_FALLBACK", "INSIGHTS_GREETING_NAME_FALLBACK", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 8216, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8132, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8448, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7516, 43),
      ))
    }

@delegate:ResourceContentHash(931_099_080)
public val Res.string.INSIGHTS_RECENTS_EMPTY_MESSAGE: StringResource by lazy {
      StringResource("string:INSIGHTS_RECENTS_EMPTY_MESSAGE", "INSIGHTS_RECENTS_EMPTY_MESSAGE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 8306, 162),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8222, 154),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8550, 178),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7606, 150),
      ))
    }

@delegate:ResourceContentHash(-440_105_474)
public val Res.string.INSIGHTS_SAVED_CONTENT_HEADER_CATEGORIES: StringResource by lazy {
      StringResource("string:INSIGHTS_SAVED_CONTENT_HEADER_CATEGORIES", "INSIGHTS_SAVED_CONTENT_HEADER_CATEGORIES", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 8469, 64),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8377, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8729, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7757, 64),
      ))
    }

@delegate:ResourceContentHash(-239_059_140)
public val Res.string.INSIGHTS_SAVED_CONTENT_HEADER_INSIGHTS: StringResource by lazy {
      StringResource("string:INSIGHTS_SAVED_CONTENT_HEADER_INSIGHTS", "INSIGHTS_SAVED_CONTENT_HEADER_INSIGHTS", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 8534, 58),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8442, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8794, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7822, 58),
      ))
    }

@delegate:ResourceContentHash(1_058_712_311)
public val Res.string.INSIGHTS_SAVED_CONTENT_HEADER_MEAL_PLANS: StringResource by lazy {
      StringResource("string:INSIGHTS_SAVED_CONTENT_HEADER_MEAL_PLANS", "INSIGHTS_SAVED_CONTENT_HEADER_MEAL_PLANS", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 8593, 64),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8497, 72),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8853, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7881, 64),
      ))
    }

@delegate:ResourceContentHash(780_301_412)
public val Res.string.INSIGHTS_SAVED_CONTENT_HEADER_RECIPES: StringResource by lazy {
      StringResource("string:INSIGHTS_SAVED_CONTENT_HEADER_RECIPES", "INSIGHTS_SAVED_CONTENT_HEADER_RECIPES", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 8658, 57),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8570, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8922, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7946, 57),
      ))
    }

@delegate:ResourceContentHash(-857_941_281)
public val Res.string.INSIGHTS_SAVED_CONTENT_HEADER_WORKOUTS: StringResource by lazy {
      StringResource("string:INSIGHTS_SAVED_CONTENT_HEADER_WORKOUTS", "INSIGHTS_SAVED_CONTENT_HEADER_WORKOUTS", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 8716, 58),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8628, 66),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8980, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8004, 58),
      ))
    }

@delegate:ResourceContentHash(1_278_090_331)
public val Res.string.INSIGHTS_TAB_ALL: StringResource by lazy {
      StringResource("string:INSIGHTS_TAB_ALL", "INSIGHTS_TAB_ALL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 8775, 32),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8695, 32),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9047, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8063, 28),
      ))
    }

@delegate:ResourceContentHash(-665_478_731)
public val Res.string.INSIGHTS_TAB_FAVORITES: StringResource by lazy {
      StringResource("string:INSIGHTS_TAB_FAVORITES", "INSIGHTS_TAB_FAVORITES", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 8808, 42),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8728, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9080, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8092, 42),
      ))
    }

@delegate:ResourceContentHash(-882_198_354)
public val Res.string.INSIGHTS_TAB_RECENTLY_VIEWED: StringResource by lazy {
      StringResource("string:INSIGHTS_TAB_RECENTLY_VIEWED", "INSIGHTS_TAB_RECENTLY_VIEWED", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 8851, 60),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8771, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9123, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8135, 56),
      ))
    }

@delegate:ResourceContentHash(-1_633_703_834)
public val Res.string.LEGAL_PRODUCT_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:LEGAL_PRODUCT_SCREEN_TITLE", "LEGAL_PRODUCT_SCREEN_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 8912, 50),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8836, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9188, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8192, 42),
      ))
    }

@delegate:ResourceContentHash(358_438_978)
public val Res.string.LIFE_TODAY_ACTIVITY_CARD_LABEL: StringResource by lazy {
      StringResource("string:LIFE_TODAY_ACTIVITY_CARD_LABEL", "LIFE_TODAY_ACTIVITY_CARD_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 8963, 54),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8879, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9231, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8235, 50),
      ))
    }

@delegate:ResourceContentHash(846_762_674)
public val Res.string.LIFE_TODAY_CALORIES_COUNTER_CALORIES_GOAL_FORMAT: StringResource by lazy {
      StringResource("string:LIFE_TODAY_CALORIES_COUNTER_CALORIES_GOAL_FORMAT", "LIFE_TODAY_CALORIES_COUNTER_CALORIES_GOAL_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 9018, 68),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8930, 68),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9282, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8286, 68),
      ))
    }

@delegate:ResourceContentHash(81_254_403)
public val Res.string.LIFE_TODAY_DAILY_TASKS_LOG_FOOD_LABEL_FORMAT: StringResource by lazy {
      StringResource("string:LIFE_TODAY_DAILY_TASKS_LOG_FOOD_LABEL_FORMAT", "LIFE_TODAY_DAILY_TASKS_LOG_FOOD_LABEL_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 9087, 72),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8999, 68),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9351, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8355, 64),
      ))
    }

@delegate:ResourceContentHash(-42_105_663)
public val Res.string.LIFE_TODAY_DAILY_TASKS_READ_INSIGHT_LABEL_FORMAT: StringResource by lazy {
      StringResource("string:LIFE_TODAY_DAILY_TASKS_READ_INSIGHT_LABEL_FORMAT", "LIFE_TODAY_DAILY_TASKS_READ_INSIGHT_LABEL_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 9160, 68),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9068, 72),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9424, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8420, 68),
      ))
    }

@delegate:ResourceContentHash(2_028_697_035)
public val Res.string.LIFE_TODAY_DAILY_TASKS_SECTION: StringResource by lazy {
      StringResource("string:LIFE_TODAY_DAILY_TASKS_SECTION", "LIFE_TODAY_DAILY_TASKS_SECTION", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 9229, 62),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9141, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9497, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8489, 54),
      ))
    }

@delegate:ResourceContentHash(332_779_021)
public val Res.string.LIFE_TODAY_LOG_SYMPTOMS_LABEL: StringResource by lazy {
      StringResource("string:LIFE_TODAY_LOG_SYMPTOMS_LABEL", "LIFE_TODAY_LOG_SYMPTOMS_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 9292, 49),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9200, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9564, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8544, 49),
      ))
    }

@delegate:ResourceContentHash(1_643_208_168)
public val Res.string.LIFE_TODAY_MEAL_PLAN_CARD_LABEL: StringResource by lazy {
      StringResource("string:LIFE_TODAY_MEAL_PLAN_CARD_LABEL", "LIFE_TODAY_MEAL_PLAN_CARD_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 9342, 55),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9250, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9618, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8594, 51),
      ))
    }

@delegate:ResourceContentHash(1_325_492_401)
public val Res.string.LIFE_TODAY_WATER_CARD_LABEL: StringResource by lazy {
      StringResource("string:LIFE_TODAY_WATER_CARD_LABEL", "LIFE_TODAY_WATER_CARD_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 9398, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9310, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9690, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8646, 43),
      ))
    }

@delegate:ResourceContentHash(-1_084_134_679)
public val Res.string.LIFE_TODAY_WEIGHT_CARD_LABEL: StringResource by lazy {
      StringResource("string:LIFE_TODAY_WEIGHT_CARD_LABEL", "LIFE_TODAY_WEIGHT_CARD_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 9442, 48),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9354, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9730, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8690, 44),
      ))
    }

@delegate:ResourceContentHash(-919_120_266)
public val Res.string.LOGIN_CONTACT_US_BUTTON: StringResource by lazy {
      StringResource("string:LOGIN_CONTACT_US_BUTTON", "LOGIN_CONTACT_US_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 9491, 59),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9399, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9775, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8735, 47),
      ))
    }

@delegate:ResourceContentHash(131_724_923)
public val Res.string.LOGIN_EMAIL_PLACEHOLDER: StringResource by lazy {
      StringResource("string:LOGIN_EMAIL_PLACEHOLDER", "LOGIN_EMAIL_PLACEHOLDER", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 9551, 39),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9447, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9827, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8783, 39),
      ))
    }

@delegate:ResourceContentHash(1_746_448_206)
public val Res.string.LOGIN_EMAIL_SENT_INSTRUCTIONS: StringResource by lazy {
      StringResource("string:LOGIN_EMAIL_SENT_INSTRUCTIONS", "LOGIN_EMAIL_SENT_INSTRUCTIONS", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 9591, 357),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9507, 369),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9867, 401),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8823, 305),
      ))
    }

@delegate:ResourceContentHash(-1_252_128_198)
public val Res.string.LOGIN_FEEDBACK_EMAIL_SUBJECT_FORMAT: StringResource by lazy {
      StringResource("string:LOGIN_FEEDBACK_EMAIL_SUBJECT_FORMAT", "LOGIN_FEEDBACK_EMAIL_SUBJECT_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 9949, 111),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9877, 143),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10269, 135),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9129, 95),
      ))
    }

@delegate:ResourceContentHash(35_747_287)
public val Res.string.LOGIN_FORGOT_PASSWORD_BUTTON: StringResource by lazy {
      StringResource("string:LOGIN_FORGOT_PASSWORD_BUTTON", "LOGIN_FORGOT_PASSWORD_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 10061, 64),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10021, 72),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10405, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9225, 60),
      ))
    }

@delegate:ResourceContentHash(-1_123_367_987)
public val Res.string.LOGIN_LOGIN_BUTTON: StringResource by lazy {
      StringResource("string:LOGIN_LOGIN_BUTTON", "LOGIN_LOGIN_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 10126, 38),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10094, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10474, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9286, 34),
      ))
    }

@delegate:ResourceContentHash(-884_429_840)
public val Res.string.LOGIN_PASSWORD_PLACEHOLDER: StringResource by lazy {
      StringResource("string:LOGIN_PASSWORD_PLACEHOLDER", "LOGIN_PASSWORD_PLACEHOLDER", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 10165, 46),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10141, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10513, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9321, 46),
      ))
    }

@delegate:ResourceContentHash(-1_123_367_987)
public val Res.string.LOGIN_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:LOGIN_SCREEN_TITLE", "LOGIN_SCREEN_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 10212, 38),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10192, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10564, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9368, 34),
      ))
    }

@delegate:ResourceContentHash(1_308_887_848)
public val Res.string.LOG_FOOD_ADD_FOOD_ACTION_BUTTON: StringResource by lazy {
      StringResource("string:LOG_FOOD_ADD_FOOD_ACTION_BUTTON", "LOG_FOOD_ADD_FOOD_ACTION_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 10251, 55),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10239, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10603, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9403, 43),
      ))
    }

@delegate:ResourceContentHash(-1_309_113_000)
public val Res.string.LOG_FOOD_ADD_MEAL_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:LOG_FOOD_ADD_MEAL_SCREEN_TITLE", "LOG_FOOD_ADD_MEAL_SCREEN_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 10307, 74),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10291, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10655, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9447, 54),
      ))
    }

@delegate:ResourceContentHash(-822_112_918)
public val Res.string.LOG_FOOD_AMOUNT_FIELD_LABEL: StringResource by lazy {
      StringResource("string:LOG_FOOD_AMOUNT_FIELD_LABEL", "LOG_FOOD_AMOUNT_FIELD_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 10382, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10354, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10718, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9502, 43),
      ))
    }

@delegate:ResourceContentHash(-1_684_385_530)
public val Res.string.LOG_FOOD_CAMERA_CANCEL_BUTTON: StringResource by lazy {
      StringResource("string:LOG_FOOD_CAMERA_CANCEL_BUTTON", "LOG_FOOD_CAMERA_CANCEL_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 10426, 49),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10402, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10766, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9546, 45),
      ))
    }

@delegate:ResourceContentHash(-1_888_846_898)
public val Res.string.LOG_FOOD_CAMERA_LOADING_MESSAGE: StringResource by lazy {
      StringResource("string:LOG_FOOD_CAMERA_LOADING_MESSAGE", "LOG_FOOD_CAMERA_LOADING_MESSAGE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 10476, 95),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10452, 107),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10816, 111),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9592, 95),
      ))
    }

@delegate:ResourceContentHash(-1_442_473_717)
public val Res.string.LOG_FOOD_CAMERA_SCAN_BUTTON: StringResource by lazy {
      StringResource("string:LOG_FOOD_CAMERA_SCAN_BUTTON", "LOG_FOOD_CAMERA_SCAN_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 10572, 47),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10560, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10928, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9688, 43),
      ))
    }

@delegate:ResourceContentHash(-1_146_069_383)
public val Res.string.LOG_FOOD_CAMERA_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:LOG_FOOD_CAMERA_SCREEN_TITLE", "LOG_FOOD_CAMERA_SCREEN_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 10620, 68),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10608, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10976, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9732, 60),
      ))
    }

@delegate:ResourceContentHash(-911_938_831)
public val Res.string.LOG_FOOD_FIND_FOOD_EMPTY_MESSAGE: StringResource by lazy {
      StringResource("string:LOG_FOOD_FIND_FOOD_EMPTY_MESSAGE", "LOG_FOOD_FIND_FOOD_EMPTY_MESSAGE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 10689, 116),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10673, 108),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11045, 116),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9793, 92),
      ))
    }

@delegate:ResourceContentHash(771_195_088)
public val Res.string.LOG_FOOD_FIND_FOOD_EMPTY_TITLE: StringResource by lazy {
      StringResource("string:LOG_FOOD_FIND_FOOD_EMPTY_TITLE", "LOG_FOOD_FIND_FOOD_EMPTY_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 10806, 102),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10782, 94),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11162, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9886, 70),
      ))
    }

@delegate:ResourceContentHash(-414_665_322)
public val Res.string.LOG_FOOD_FIND_FOOD_SCAN_BARCODE_BUTTON: StringResource by lazy {
      StringResource("string:LOG_FOOD_FIND_FOOD_SCAN_BARCODE_BUTTON", "LOG_FOOD_FIND_FOOD_SCAN_BARCODE_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 10909, 66),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10877, 82),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11253, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9957, 62),
      ))
    }

@delegate:ResourceContentHash(1_671_510_126)
public val Res.string.LOG_FOOD_FIND_FOOD_SEARCH_FIELD_PLACEHOLDER: StringResource by lazy {
      StringResource("string:LOG_FOOD_FIND_FOOD_SEARCH_FIELD_PLACEHOLDER", "LOG_FOOD_FIND_FOOD_SEARCH_FIELD_PLACEHOLDER", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 10976, 63),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10960, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11332, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10020, 63),
      ))
    }

@delegate:ResourceContentHash(1_152_338_271)
public val Res.string.LOG_FOOD_FOOD_DETAILS_CALORIES_UNIT_LABEL: StringResource by lazy {
      StringResource("string:LOG_FOOD_FOOD_DETAILS_CALORIES_UNIT_LABEL", "LOG_FOOD_FOOD_DETAILS_CALORIES_UNIT_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 11040, 61),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 11024, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11400, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10084, 61),
      ))
    }

@delegate:ResourceContentHash(427_970_713)
public val Res.string.LOG_FOOD_FOOD_DETAILS_CARBS_LABEL: StringResource by lazy {
      StringResource("string:LOG_FOOD_FOOD_DETAILS_CARBS_LABEL", "LOG_FOOD_FOOD_DETAILS_CARBS_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 11102, 61),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 11086, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11462, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10146, 49),
      ))
    }

@delegate:ResourceContentHash(-2_106_960_933)
public val Res.string.LOG_FOOD_FOOD_DETAILS_FAT_LABEL: StringResource by lazy {
      StringResource("string:LOG_FOOD_FOOD_DETAILS_FAT_LABEL", "LOG_FOOD_FOOD_DETAILS_FAT_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 11164, 47),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 11148, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11520, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10196, 47),
      ))
    }

@delegate:ResourceContentHash(70_773_492)
public val Res.string.LOG_FOOD_FOOD_DETAILS_FIBER_LABEL: StringResource by lazy {
      StringResource("string:LOG_FOOD_FOOD_DETAILS_FIBER_LABEL", "LOG_FOOD_FOOD_DETAILS_FIBER_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 11212, 61),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 11200, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11572, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10244, 49),
      ))
    }

@delegate:ResourceContentHash(137_085_866)
public val Res.string.LOG_FOOD_FOOD_DETAILS_PROTEIN_LABEL: StringResource by lazy {
      StringResource("string:LOG_FOOD_FOOD_DETAILS_PROTEIN_LABEL", "LOG_FOOD_FOOD_DETAILS_PROTEIN_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 11274, 55),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 11250, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11626, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10294, 55),
      ))
    }

@delegate:ResourceContentHash(-172_425_324)
public val Res.string.LOG_FOOD_LOG_TIME_FIELD_LABEL: StringResource by lazy {
      StringResource("string:LOG_FOOD_LOG_TIME_FIELD_LABEL", "LOG_FOOD_LOG_TIME_FIELD_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 11330, 65),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 11310, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11686, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10350, 49),
      ))
    }

@delegate:ResourceContentHash(-1_554_853_115)
public val Res.string.LOG_FOOD_SCAN_ERROR_IMAGE_TOO_LARGE: StringResource by lazy {
      StringResource("string:LOG_FOOD_SCAN_ERROR_IMAGE_TOO_LARGE", "LOG_FOOD_SCAN_ERROR_IMAGE_TOO_LARGE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 11396, 111),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 11368, 123),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11752, 103),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10400, 95),
      ))
    }

@delegate:ResourceContentHash(1_667_918_201)
public val Res.string.LOG_FOOD_SCAN_ERROR_NOT_FOOD: StringResource by lazy {
      StringResource("string:LOG_FOOD_SCAN_ERROR_NOT_FOOD", "LOG_FOOD_SCAN_ERROR_NOT_FOOD", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 11508, 124),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 11492, 124),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11856, 120),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10496, 104),
      ))
    }

@delegate:ResourceContentHash(1_208_243_456)
public val Res.string.LOG_FOOD_SCAN_ERROR_QUOTA_EXCEEDED: StringResource by lazy {
      StringResource("string:LOG_FOOD_SCAN_ERROR_QUOTA_EXCEEDED", "LOG_FOOD_SCAN_ERROR_QUOTA_EXCEEDED", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 11633, 150),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 11617, 170),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11977, 142),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10601, 122),
      ))
    }

@delegate:ResourceContentHash(1_625_489_822)
public val Res.string.LOG_FOOD_SCAN_ERROR_SERVICE_UNAVAILABLE: StringResource by lazy {
      StringResource("string:LOG_FOOD_SCAN_ERROR_SERVICE_UNAVAILABLE", "LOG_FOOD_SCAN_ERROR_SERVICE_UNAVAILABLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 11784, 151),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 11788, 139),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12120, 139),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10724, 123),
      ))
    }

@delegate:ResourceContentHash(-1_943_348_278)
public val Res.string.LOG_FOOD_SCAN_FOOD_BUTTON: StringResource by lazy {
      StringResource("string:LOG_FOOD_SCAN_FOOD_BUTTON", "LOG_FOOD_SCAN_FOOD_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 11936, 61),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 11928, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12260, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10848, 45),
      ))
    }

@delegate:ResourceContentHash(1_308_887_848)
public val Res.string.LOG_FOOD_SCAN_RESULTS_ADD_BUTTON: StringResource by lazy {
      StringResource("string:LOG_FOOD_SCAN_RESULTS_ADD_BUTTON", "LOG_FOOD_SCAN_RESULTS_ADD_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 11998, 56),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 11982, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12322, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10894, 44),
      ))
    }

@delegate:ResourceContentHash(-1_159_753_688)
public val Res.string.LOG_FOOD_SCAN_RESULTS_CLOSE_BUTTON: StringResource by lazy {
      StringResource("string:LOG_FOOD_SCAN_RESULTS_CLOSE_BUTTON", "LOG_FOOD_SCAN_RESULTS_CLOSE_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 12055, 58),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12035, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12375, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10939, 50),
      ))
    }

@delegate:ResourceContentHash(-1_684_385_530)
public val Res.string.LOG_FOOD_SCAN_RESULTS_DELETE_CANCEL: StringResource by lazy {
      StringResource("string:LOG_FOOD_SCAN_RESULTS_DELETE_CANCEL", "LOG_FOOD_SCAN_RESULTS_DELETE_CANCEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 12114, 55),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12086, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12426, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10990, 51),
      ))
    }

@delegate:ResourceContentHash(1_508_685_540)
public val Res.string.LOG_FOOD_SCAN_RESULTS_DELETE_CONFIRM: StringResource by lazy {
      StringResource("string:LOG_FOOD_SCAN_RESULTS_DELETE_CONFIRM", "LOG_FOOD_SCAN_RESULTS_DELETE_CONFIRM", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 12170, 56),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12142, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12482, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11042, 52),
      ))
    }

@delegate:ResourceContentHash(-263_192_608)
public val Res.string.LOG_FOOD_SCAN_RESULTS_DELETE_ITEM_TITLE: StringResource by lazy {
      StringResource("string:LOG_FOOD_SCAN_RESULTS_DELETE_ITEM_TITLE", "LOG_FOOD_SCAN_RESULTS_DELETE_ITEM_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 12227, 83),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12199, 83),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12539, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11095, 71),
      ))
    }

@delegate:ResourceContentHash(1_793_564_813)
public val Res.string.LOG_FOOD_SCAN_RESULTS_TITLE: StringResource by lazy {
      StringResource("string:LOG_FOOD_SCAN_RESULTS_TITLE", "LOG_FOOD_SCAN_RESULTS_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 12311, 63),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12283, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12623, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11167, 47),
      ))
    }

@delegate:ResourceContentHash(1_044_493_803)
public val Res.string.LOG_FOOD_SCAN_RESULTS_TOTAL_LABEL: StringResource by lazy {
      StringResource("string:LOG_FOOD_SCAN_RESULTS_TOTAL_LABEL", "LOG_FOOD_SCAN_RESULTS_TOTAL_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 12375, 49),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12339, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12683, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11215, 49),
      ))
    }

@delegate:ResourceContentHash(-1_310_097_761)
public val Res.string.LOG_PERIOD_MARK_DATES_TITLE: StringResource by lazy {
      StringResource("string:LOG_PERIOD_MARK_DATES_TITLE", "LOG_PERIOD_MARK_DATES_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 12425, 71),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12389, 83),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12733, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11265, 59),
      ))
    }

@delegate:ResourceContentHash(1_138_601_962)
public val Res.string.LOG_SYMPTOMS_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:LOG_SYMPTOMS_SCREEN_TITLE", "LOG_SYMPTOMS_SCREEN_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 12497, 65),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12473, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12813, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11325, 49),
      ))
    }

@delegate:ResourceContentHash(-1_159_753_688)
public val Res.string.LOG_WATER_CLOSE_BUTTON: StringResource by lazy {
      StringResource("string:LOG_WATER_CLOSE_BUTTON", "LOG_WATER_CLOSE_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 12563, 46),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12535, 38),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12883, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11375, 38),
      ))
    }

@delegate:ResourceContentHash(2_000_318_750)
public val Res.string.LOG_WATER_PERSONAL_AMOUNT_LABEL: StringResource by lazy {
      StringResource("string:LOG_WATER_PERSONAL_AMOUNT_LABEL", "LOG_WATER_PERSONAL_AMOUNT_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 12610, 87),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12574, 79),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12922, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11414, 79),
      ))
    }

@delegate:ResourceContentHash(1_648_635_578)
public val Res.string.LOG_WATER_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:LOG_WATER_SCREEN_TITLE", "LOG_WATER_SCREEN_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 12698, 50),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12654, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 13022, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11494, 46),
      ))
    }

@delegate:ResourceContentHash(131_724_923)
public val Res.string.MAGIC_LINK_EMAIL_PLACEHOLDER: StringResource by lazy {
      StringResource("string:MAGIC_LINK_EMAIL_PLACEHOLDER", "MAGIC_LINK_EMAIL_PLACEHOLDER", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 12749, 44),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12705, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 13077, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11541, 44),
      ))
    }

@delegate:ResourceContentHash(2_112_206_338)
public val Res.string.MAGIC_LINK_INSTRUCTIONS: StringResource by lazy {
      StringResource("string:MAGIC_LINK_INSTRUCTIONS", "MAGIC_LINK_INSTRUCTIONS", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 12794, 363),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12770, 327),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 13122, 391),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11586, 299),
      ))
    }

@delegate:ResourceContentHash(360_086_602)
public val Res.string.MAGIC_LINK_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:MAGIC_LINK_SCREEN_TITLE", "MAGIC_LINK_SCREEN_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 13158, 55),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13098, 67),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 13514, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11886, 51),
      ))
    }

@delegate:ResourceContentHash(407_645_370)
public val Res.string.MAGIC_LINK_SEND_BUTTON: StringResource by lazy {
      StringResource("string:MAGIC_LINK_SEND_BUTTON", "MAGIC_LINK_SEND_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 13214, 70),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13166, 74),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 13574, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11938, 50),
      ))
    }

@delegate:ResourceContentHash(-1_273_654_431)
public val Res.string.MAGIC_LINK_SUCCESS_MESSAGE: StringResource by lazy {
      StringResource("string:MAGIC_LINK_SUCCESS_MESSAGE", "MAGIC_LINK_SUCCESS_MESSAGE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 13285, 210),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13241, 214),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 13653, 222),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11989, 170),
      ))
    }

@delegate:ResourceContentHash(438_418_870)
public val Res.string.MAGIC_LINK_SUCCESS_TITLE: StringResource by lazy {
      StringResource("string:MAGIC_LINK_SUCCESS_TITLE", "MAGIC_LINK_SUCCESS_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 13496, 64),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13456, 72),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 13876, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12160, 56),
      ))
    }

@delegate:ResourceContentHash(-1_778_437_004)
public val Res.string.MAIN_BANNER_APP_PROMO_TITLE: StringResource by lazy {
      StringResource("string:MAIN_BANNER_APP_PROMO_TITLE", "MAIN_BANNER_APP_PROMO_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 13561, 135),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13529, 147),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 13937, 159),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12217, 111),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString1Resources(map: MutableMap<String, StringResource>) {
  map.put("GENERAL_UNIT_ML_LABEL", Res.string.GENERAL_UNIT_ML_LABEL)
  map.put("GENERAL_UNIT_OZ_LABEL", Res.string.GENERAL_UNIT_OZ_LABEL)
  map.put("GENERAL_UNIT_PIECE_LABEL", Res.string.GENERAL_UNIT_PIECE_LABEL)
  map.put("GENERAL_UNIT_TBSP_LABEL", Res.string.GENERAL_UNIT_TBSP_LABEL)
  map.put("GENERAL_UNIT_TSP_LABEL", Res.string.GENERAL_UNIT_TSP_LABEL)
  map.put("GENERAL_WEIGHT_CUP_FORMAT", Res.string.GENERAL_WEIGHT_CUP_FORMAT)
  map.put("GENERAL_WEIGHT_FL_OZ_FORMAT", Res.string.GENERAL_WEIGHT_FL_OZ_FORMAT)
  map.put("GENERAL_WEIGHT_GRAM_FORMAT", Res.string.GENERAL_WEIGHT_GRAM_FORMAT)
  map.put("GENERAL_WEIGHT_KG_FORMAT", Res.string.GENERAL_WEIGHT_KG_FORMAT)
  map.put("GENERAL_WEIGHT_LB_FORMAT", Res.string.GENERAL_WEIGHT_LB_FORMAT)
  map.put("GENERAL_WEIGHT_MEAL_FORMAT", Res.string.GENERAL_WEIGHT_MEAL_FORMAT)
  map.put("GENERAL_WEIGHT_ML_FORMAT", Res.string.GENERAL_WEIGHT_ML_FORMAT)
  map.put("GENERAL_WEIGHT_OZ_FORMAT", Res.string.GENERAL_WEIGHT_OZ_FORMAT)
  map.put("GENERAL_WEIGHT_PIECE_FORMAT", Res.string.GENERAL_WEIGHT_PIECE_FORMAT)
  map.put("GENERAL_WEIGHT_TBSP_FORMAT", Res.string.GENERAL_WEIGHT_TBSP_FORMAT)
  map.put("GENERAL_WEIGHT_TSP_FORMAT", Res.string.GENERAL_WEIGHT_TSP_FORMAT)
  map.put("HEALTH_KIT_APPLE_HEALTH_NAME", Res.string.HEALTH_KIT_APPLE_HEALTH_NAME)
  map.put("HEALTH_KIT_CONNECTION_TITLE_FORMAT", Res.string.HEALTH_KIT_CONNECTION_TITLE_FORMAT)
  map.put("HEALTH_KIT_CONNECT_BUTTON", Res.string.HEALTH_KIT_CONNECT_BUTTON)
  map.put("HEALTH_KIT_HEALTH_CONNECT_NAME", Res.string.HEALTH_KIT_HEALTH_CONNECT_NAME)
  map.put("HEALTH_KIT_MANAGE_HINT_ANDROID_FORMAT", Res.string.HEALTH_KIT_MANAGE_HINT_ANDROID_FORMAT)
  map.put("HEALTH_KIT_MANAGE_HINT_IOS_FORMAT", Res.string.HEALTH_KIT_MANAGE_HINT_IOS_FORMAT)
  map.put("HEALTH_KIT_MANAGE_PERMISSIONS_BUTTON", Res.string.HEALTH_KIT_MANAGE_PERMISSIONS_BUTTON)
  map.put("HEALTH_KIT_SYNC_DESCRIPTION", Res.string.HEALTH_KIT_SYNC_DESCRIPTION)
  map.put("HEALTH_LOG_SAVE_BUTTON", Res.string.HEALTH_LOG_SAVE_BUTTON)
  map.put("HEALTH_LOG_SCREEN_TITLE", Res.string.HEALTH_LOG_SCREEN_TITLE)
  map.put("HEALTH_TOOLS_SCREEN_TITLE", Res.string.HEALTH_TOOLS_SCREEN_TITLE)
  map.put("INSIGHTS_FAVORITES_EMPTY_BUTTON_TEXT", Res.string.INSIGHTS_FAVORITES_EMPTY_BUTTON_TEXT)
  map.put("INSIGHTS_FAVORITES_EMPTY_MESSAGE", Res.string.INSIGHTS_FAVORITES_EMPTY_MESSAGE)
  map.put("INSIGHTS_FAVORITES_EMPTY_TITLE", Res.string.INSIGHTS_FAVORITES_EMPTY_TITLE)
  map.put("INSIGHTS_GREETING", Res.string.INSIGHTS_GREETING)
  map.put("INSIGHTS_GREETING_NAME_FALLBACK", Res.string.INSIGHTS_GREETING_NAME_FALLBACK)
  map.put("INSIGHTS_RECENTS_EMPTY_MESSAGE", Res.string.INSIGHTS_RECENTS_EMPTY_MESSAGE)
  map.put("INSIGHTS_SAVED_CONTENT_HEADER_CATEGORIES", Res.string.INSIGHTS_SAVED_CONTENT_HEADER_CATEGORIES)
  map.put("INSIGHTS_SAVED_CONTENT_HEADER_INSIGHTS", Res.string.INSIGHTS_SAVED_CONTENT_HEADER_INSIGHTS)
  map.put("INSIGHTS_SAVED_CONTENT_HEADER_MEAL_PLANS", Res.string.INSIGHTS_SAVED_CONTENT_HEADER_MEAL_PLANS)
  map.put("INSIGHTS_SAVED_CONTENT_HEADER_RECIPES", Res.string.INSIGHTS_SAVED_CONTENT_HEADER_RECIPES)
  map.put("INSIGHTS_SAVED_CONTENT_HEADER_WORKOUTS", Res.string.INSIGHTS_SAVED_CONTENT_HEADER_WORKOUTS)
  map.put("INSIGHTS_TAB_ALL", Res.string.INSIGHTS_TAB_ALL)
  map.put("INSIGHTS_TAB_FAVORITES", Res.string.INSIGHTS_TAB_FAVORITES)
  map.put("INSIGHTS_TAB_RECENTLY_VIEWED", Res.string.INSIGHTS_TAB_RECENTLY_VIEWED)
  map.put("LEGAL_PRODUCT_SCREEN_TITLE", Res.string.LEGAL_PRODUCT_SCREEN_TITLE)
  map.put("LIFE_TODAY_ACTIVITY_CARD_LABEL", Res.string.LIFE_TODAY_ACTIVITY_CARD_LABEL)
  map.put("LIFE_TODAY_CALORIES_COUNTER_CALORIES_GOAL_FORMAT", Res.string.LIFE_TODAY_CALORIES_COUNTER_CALORIES_GOAL_FORMAT)
  map.put("LIFE_TODAY_DAILY_TASKS_LOG_FOOD_LABEL_FORMAT", Res.string.LIFE_TODAY_DAILY_TASKS_LOG_FOOD_LABEL_FORMAT)
  map.put("LIFE_TODAY_DAILY_TASKS_READ_INSIGHT_LABEL_FORMAT", Res.string.LIFE_TODAY_DAILY_TASKS_READ_INSIGHT_LABEL_FORMAT)
  map.put("LIFE_TODAY_DAILY_TASKS_SECTION", Res.string.LIFE_TODAY_DAILY_TASKS_SECTION)
  map.put("LIFE_TODAY_LOG_SYMPTOMS_LABEL", Res.string.LIFE_TODAY_LOG_SYMPTOMS_LABEL)
  map.put("LIFE_TODAY_MEAL_PLAN_CARD_LABEL", Res.string.LIFE_TODAY_MEAL_PLAN_CARD_LABEL)
  map.put("LIFE_TODAY_WATER_CARD_LABEL", Res.string.LIFE_TODAY_WATER_CARD_LABEL)
  map.put("LIFE_TODAY_WEIGHT_CARD_LABEL", Res.string.LIFE_TODAY_WEIGHT_CARD_LABEL)
  map.put("LOGIN_CONTACT_US_BUTTON", Res.string.LOGIN_CONTACT_US_BUTTON)
  map.put("LOGIN_EMAIL_PLACEHOLDER", Res.string.LOGIN_EMAIL_PLACEHOLDER)
  map.put("LOGIN_EMAIL_SENT_INSTRUCTIONS", Res.string.LOGIN_EMAIL_SENT_INSTRUCTIONS)
  map.put("LOGIN_FEEDBACK_EMAIL_SUBJECT_FORMAT", Res.string.LOGIN_FEEDBACK_EMAIL_SUBJECT_FORMAT)
  map.put("LOGIN_FORGOT_PASSWORD_BUTTON", Res.string.LOGIN_FORGOT_PASSWORD_BUTTON)
  map.put("LOGIN_LOGIN_BUTTON", Res.string.LOGIN_LOGIN_BUTTON)
  map.put("LOGIN_PASSWORD_PLACEHOLDER", Res.string.LOGIN_PASSWORD_PLACEHOLDER)
  map.put("LOGIN_SCREEN_TITLE", Res.string.LOGIN_SCREEN_TITLE)
  map.put("LOG_FOOD_ADD_FOOD_ACTION_BUTTON", Res.string.LOG_FOOD_ADD_FOOD_ACTION_BUTTON)
  map.put("LOG_FOOD_ADD_MEAL_SCREEN_TITLE", Res.string.LOG_FOOD_ADD_MEAL_SCREEN_TITLE)
  map.put("LOG_FOOD_AMOUNT_FIELD_LABEL", Res.string.LOG_FOOD_AMOUNT_FIELD_LABEL)
  map.put("LOG_FOOD_CAMERA_CANCEL_BUTTON", Res.string.LOG_FOOD_CAMERA_CANCEL_BUTTON)
  map.put("LOG_FOOD_CAMERA_LOADING_MESSAGE", Res.string.LOG_FOOD_CAMERA_LOADING_MESSAGE)
  map.put("LOG_FOOD_CAMERA_SCAN_BUTTON", Res.string.LOG_FOOD_CAMERA_SCAN_BUTTON)
  map.put("LOG_FOOD_CAMERA_SCREEN_TITLE", Res.string.LOG_FOOD_CAMERA_SCREEN_TITLE)
  map.put("LOG_FOOD_FIND_FOOD_EMPTY_MESSAGE", Res.string.LOG_FOOD_FIND_FOOD_EMPTY_MESSAGE)
  map.put("LOG_FOOD_FIND_FOOD_EMPTY_TITLE", Res.string.LOG_FOOD_FIND_FOOD_EMPTY_TITLE)
  map.put("LOG_FOOD_FIND_FOOD_SCAN_BARCODE_BUTTON", Res.string.LOG_FOOD_FIND_FOOD_SCAN_BARCODE_BUTTON)
  map.put("LOG_FOOD_FIND_FOOD_SEARCH_FIELD_PLACEHOLDER", Res.string.LOG_FOOD_FIND_FOOD_SEARCH_FIELD_PLACEHOLDER)
  map.put("LOG_FOOD_FOOD_DETAILS_CALORIES_UNIT_LABEL", Res.string.LOG_FOOD_FOOD_DETAILS_CALORIES_UNIT_LABEL)
  map.put("LOG_FOOD_FOOD_DETAILS_CARBS_LABEL", Res.string.LOG_FOOD_FOOD_DETAILS_CARBS_LABEL)
  map.put("LOG_FOOD_FOOD_DETAILS_FAT_LABEL", Res.string.LOG_FOOD_FOOD_DETAILS_FAT_LABEL)
  map.put("LOG_FOOD_FOOD_DETAILS_FIBER_LABEL", Res.string.LOG_FOOD_FOOD_DETAILS_FIBER_LABEL)
  map.put("LOG_FOOD_FOOD_DETAILS_PROTEIN_LABEL", Res.string.LOG_FOOD_FOOD_DETAILS_PROTEIN_LABEL)
  map.put("LOG_FOOD_LOG_TIME_FIELD_LABEL", Res.string.LOG_FOOD_LOG_TIME_FIELD_LABEL)
  map.put("LOG_FOOD_SCAN_ERROR_IMAGE_TOO_LARGE", Res.string.LOG_FOOD_SCAN_ERROR_IMAGE_TOO_LARGE)
  map.put("LOG_FOOD_SCAN_ERROR_NOT_FOOD", Res.string.LOG_FOOD_SCAN_ERROR_NOT_FOOD)
  map.put("LOG_FOOD_SCAN_ERROR_QUOTA_EXCEEDED", Res.string.LOG_FOOD_SCAN_ERROR_QUOTA_EXCEEDED)
  map.put("LOG_FOOD_SCAN_ERROR_SERVICE_UNAVAILABLE", Res.string.LOG_FOOD_SCAN_ERROR_SERVICE_UNAVAILABLE)
  map.put("LOG_FOOD_SCAN_FOOD_BUTTON", Res.string.LOG_FOOD_SCAN_FOOD_BUTTON)
  map.put("LOG_FOOD_SCAN_RESULTS_ADD_BUTTON", Res.string.LOG_FOOD_SCAN_RESULTS_ADD_BUTTON)
  map.put("LOG_FOOD_SCAN_RESULTS_CLOSE_BUTTON", Res.string.LOG_FOOD_SCAN_RESULTS_CLOSE_BUTTON)
  map.put("LOG_FOOD_SCAN_RESULTS_DELETE_CANCEL", Res.string.LOG_FOOD_SCAN_RESULTS_DELETE_CANCEL)
  map.put("LOG_FOOD_SCAN_RESULTS_DELETE_CONFIRM", Res.string.LOG_FOOD_SCAN_RESULTS_DELETE_CONFIRM)
  map.put("LOG_FOOD_SCAN_RESULTS_DELETE_ITEM_TITLE", Res.string.LOG_FOOD_SCAN_RESULTS_DELETE_ITEM_TITLE)
  map.put("LOG_FOOD_SCAN_RESULTS_TITLE", Res.string.LOG_FOOD_SCAN_RESULTS_TITLE)
  map.put("LOG_FOOD_SCAN_RESULTS_TOTAL_LABEL", Res.string.LOG_FOOD_SCAN_RESULTS_TOTAL_LABEL)
  map.put("LOG_PERIOD_MARK_DATES_TITLE", Res.string.LOG_PERIOD_MARK_DATES_TITLE)
  map.put("LOG_SYMPTOMS_SCREEN_TITLE", Res.string.LOG_SYMPTOMS_SCREEN_TITLE)
  map.put("LOG_WATER_CLOSE_BUTTON", Res.string.LOG_WATER_CLOSE_BUTTON)
  map.put("LOG_WATER_PERSONAL_AMOUNT_LABEL", Res.string.LOG_WATER_PERSONAL_AMOUNT_LABEL)
  map.put("LOG_WATER_SCREEN_TITLE", Res.string.LOG_WATER_SCREEN_TITLE)
  map.put("MAGIC_LINK_EMAIL_PLACEHOLDER", Res.string.MAGIC_LINK_EMAIL_PLACEHOLDER)
  map.put("MAGIC_LINK_INSTRUCTIONS", Res.string.MAGIC_LINK_INSTRUCTIONS)
  map.put("MAGIC_LINK_SCREEN_TITLE", Res.string.MAGIC_LINK_SCREEN_TITLE)
  map.put("MAGIC_LINK_SEND_BUTTON", Res.string.MAGIC_LINK_SEND_BUTTON)
  map.put("MAGIC_LINK_SUCCESS_MESSAGE", Res.string.MAGIC_LINK_SUCCESS_MESSAGE)
  map.put("MAGIC_LINK_SUCCESS_TITLE", Res.string.MAGIC_LINK_SUCCESS_TITLE)
  map.put("MAIN_BANNER_APP_PROMO_TITLE", Res.string.MAIN_BANNER_APP_PROMO_TITLE)
}
